import script from "./DragDropStation.vue?vue&type=script&setup=true&lang=js"
export * from "./DragDropStation.vue?vue&type=script&setup=true&lang=js"

import "./DragDropStation.vue?vue&type=style&index=0&id=03054aa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03054aa1"]])

export default __exports__